module.exports = __webpack_public_path__ + "img/fcb-logo-vn.d4f47f08.png";